import { useMemo } from 'react';

import { useTranslation } from 'react-i18next'; // 引入国际化 Hook
import { Link } from 'react-router-dom';

import ScrollView from '@/components/ScrollView';
import new1 from '@/image/new1.png';
import new2 from '@/image/new2.png';
import new3 from '@/image/new3.png';
import ReturnCom from '@/components/ReturnCom';

const Information = () => {
    const { t } = useTranslation(); // 使用国际化 Hook

    const data = useMemo(() => {
        return [
            {
                title: t('information.title1'), // 使用国际化文本
                p: t('information.description1'), // 使用国际化文本
                link: [
                    'https://tidenews.com.cn/tmh_news.html?id=6709cb9fa8070500014d81d1&source=weixin',
                    'https://www.toutiao.com/article/7424678032742416906/?app=news_article&timestamp=1728798927&use_new_style=1&req_id=202410131355273E0823CA54AADC8C949B&group_id=7424678032742416906&wxshare_count=1&tt_from=weixin&utm_source=weixin&utm_medium=toutiao_android&utm_campaign=client_share&share_token=c8a87cd0-c45b-4f13-9e3d-be7bcf2ec2fa&source=m_redirect'
                ],
                img: new1
            },
            {
                title: t('information.title1'), // 使用国际化文本
                p: t('information.description1'), // 使用国际化文本
                link: [
                    'https://tidenews.com.cn/tmh_news.html?id=6709cb9fa8070500014d81d1&source=weixin',
                    'https://www.toutiao.com/article/7424678032742416906/?app=news_article&timestamp=1728798927&use_new_style=1&req_id=202410131355273E0823CA54AADC8C949B&group_id=7424678032742416906&wxshare_count=1&tt_from=weixin&utm_source=weixin&utm_medium=toutiao_android&utm_campaign=client_share&share_token=c8a87cd0-c45b-4f13-9e3d-be7bcf2ec2fa&source=m_redirect'
                ],
                img: new1
            },
            {
                title: t('information.title2'), // 使用国际化文本
                p: t('information.description2'), // 使用国际化文本
                link: ['https://www.metaera.hk/gw_detail?id=188924'],
                img: new2
            },
            {
                title: t('information.title3'), // 使用国际化文本
                p: t('information.description3'), // 使用国际化文本
                link: [
                    'https://page.om.qq.com/page/Oku_7QxFKf3OOmehLApSHGoQ0',
                    'https://www.jinse.cn/news/blockchain/3681035.html'
                ],
                img: new3
            }
        ];
    }, [t]);

    return (
        <div>
            <div className='md:max-w-[900px] md:mx-auto md:mt-6 px-4 mt-3.5'>
                < ReturnCom title={t('information.publishNews')} />
            </div>
            <ScrollView className=" p-4 rounded-2xl" px={'120px'}>
                <div className="mb-5 text-white rounded-xl bg-21 border border-5c py-2.5 px-2.5 text-10px whitespace-pre-wrap">
                    {/* 关于NFX生态公链数据平移及跨链服务暂停的通知<br />
                    各位NFX生态用户：<br />
                    为进一步优化NFX生态架构，提升生态系统安全稳定性，保障项目长期稳健、可持续发展，经项目团队统筹规划，现正式启动公链平移升级工作。<br />
                    本次将进行Fibonacci公链向INTL公链数据整体数据平移迁移，平移周期为2026年9月7日14:00 至2026年10月15日14:00。为保障平移工作顺利推进、数据完整无误，平移期间将临时暂停NFX跨链服务和NFX链上操作服务，望各位用户知悉。<br />
                    特此郑重说明，本次公链数据平移升级仅影响跨链相关功能和NFX链上操作服务，完全不影响所有用户的NFX正常收益和机制、收益结算规则保持不变，用户资产及生态权益全程安全可控。<br />
                    本次升级是NFX生态迭代升级的重要举措，将为生态后续发展筑牢底层基础。后续项目团队将实时同步迁移进度，如有相关疑问，可咨询官方客服。感谢所有用户的理解、支持与陪伴！<br />
                    ★特别提醒:<br />
                    1，请保管好原有助记词/私钥；<br />
                    2，届时请关注线上培训指导，提供在线操作服务支持；<br />
                    NFX生态项目团队<br /> */}
                    {t('information.text5')}
                </div>
                {data.map((item, index) => {
                    return (
                        <div key={index} className="mb-5 text-white rounded-xl bg-21 border border-5c py-2.5">
                            <div className="border-b pb-2.5 border-5c px-2.5 flex items-center text-10px">
                                <div className=" mr-2.5">
                                    <div className="line-clamp-2  font-semibold">{item.title}</div>
                                    <p className=" line-clamp-4">{item.p}</p>
                                </div>
                                <img className="w-35" src={item.img} alt="" />
                            </div>
                            <div className="pt-2.5 px-2.5 text-xs">
                                <p className="">
                                    {t('information.clickHere')}
                                    <Link
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        to={item.link[0]}
                                        className="cursor-pointer font-semibold text-fa"
                                    >
                                        {t('information.here')}
                                    </Link>
                                    {t('information.viewConference')}
                                </p>
                                <div className="pt-2  font-semibold text-fa">
                                    {item.link.map((v, i) => {
                                        return (
                                            <Link
                                                key={i + 'text'}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className=" line-clamp-1 cursor-pointer"
                                                to={v}
                                            >
                                                {v}
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </ScrollView>
        </div>
    );
};

export default Information;